import * as echarts from 'echarts/core'

import { MapChart } from 'echarts/charts'
// import { GeoJSON } from "echarts/types/src/coord/geo/geoTypes";

import {
    LegendComponent,
    TitleComponent,
    TooltipComponent,
    VisualMapComponent,
} from 'echarts/components'

import { SVGRenderer } from 'echarts/renderers'

import worldGeoJSON from './world.json'

import EChart, { SCHEMES, TOOLTIP_OPTIONS } from '../index'

// Register required ECharts modules

echarts.use([
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    VisualMapComponent,
    SVGRenderer,
    MapChart,
])

// Register the map data

echarts.registerMap('World', worldGeoJSON as any)

export { SCHEMES, TOOLTIP_OPTIONS }

export default EChart
